import axios from '@_system/axios/axios.js'
export default {
	path: '/upload',
	file(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/file', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	download(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/download', data, (res) => {
				resolve(res)
			},reject,true)
		})
	},
	config(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/config', data, (res) => {
				resolve(res)
			},reject,true)
		})
	}
	
	
	
}
